/**
 * Add the register file to the manager entries for storybook addons.
 *
 * @param entries The current manager entries.
 * @returns The new manager entries.
 */
const managerEntries = (entries = []) => [...entries, require.resolve('./manager')];

export default {managerEntries};